import { Tooltip } from '@/shared/components/Tooltip'

/** A pass/fail policy dot driven by the workspace block flag (M2 gate sets it on a violation). */
export function PolicyDot({ blocked }: { blocked?: number }) {
  const fail = blocked === 1
  return (
    <Tooltip text={fail ? 'Policy gate: next apply is blocked' : 'Policy gate: clear'} placement="top">
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: '0.62rem', color: fail ? 'var(--red)' : 'var(--green)' }}>
        <span style={{ fontSize: '0.7rem' }}>{fail ? '●' : '●'}</span>{fail ? 'blocked' : 'clear'}
      </span>
    </Tooltip>
  )
}

